<ng-template #attente>
  <br>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="!generaleService.disabled;else attente"></div>

<div class="display-flex">
  <div class="manager">
    <h4>Creation et modification blogue</h4>
    <div class="display-flex" >
      <div style="width: 280px;">
        <h6>1300 / 400</h6>
        <img [src]="mainImage.File_Content" height="100px" width="280px" (click)="openFrmImage('ajouterProncipale')">
      </div>
      <div class="select">
        <mat-form-field class="type-blogue">
          <mat-select name="type" [(ngModel)]="blogue.ecBlog_Code" placeholder="Type blogue"
            (selectionChange)="ecBlogD_CodeChange()" required>
            <mat-option *ngFor="let type of listeType" [value]="type.value">{{type.text}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="type-blogue">
          <mat-select name="type2" [(ngModel)]="blogue.ecBlogD_Groupe" placeholder="Sous type" required>
            <mat-option *ngFor="let type of listeSoustTypeFiltred" [value]="type.code">{{type.fr}}</mat-option>
          </mat-select>
        </mat-form-field>       
      </div>
      <div class="btn">
        <button (click)="modifier()" [disabled]="generaleService.disabled" mat-raised-button
          class="colorGreen">Modifier blogue</button>
        <button (click)="ajouter()" [disabled]="generaleService.disabled" mat-raised-button
          class="colorGreen">Ajouter blogue</button>
        <button (click)="supprimer()" [disabled]="generaleService.disabled" mat-raised-button
          class="colorReed">Supprimer blogue</button>
        <button *ngIf="blogue.ecBlog_Code" (click)="showListeSousType(frmSousType)" [disabled]="generaleService.disabled" mat-raised-button
          class="colorGreen">Liste sous type</button>
      </div>
    </div>
    <mat-accordion>
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Titre principale
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex5" placeholder="Titre principale Fr" [(ngModel)]="blogue_TitreFr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex6" placeholder="Titre principale En" [(ngModel)]="blogue_TitreEn">
            </angular-editor>
          </div>
        </div>

      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Titre 1
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex5" placeholder="Titre 1 Fr"
              [(ngModel)]="blogue_T1Fr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex6" placeholder="Titre 1 En" [(ngModel)]="blogue_T1En">
            </angular-editor>
          </div>
        </div>

      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Paragraphe 1
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex5" placeholder="Paragraphe 1 Fr"
              [(ngModel)]="blogue_P1Fr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex6" placeholder="aragraphe 1 En" [(ngModel)]="blogue_P1En">
            </angular-editor>
          </div>
        </div>

      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Titre 2
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex3" placeholder="Titre 2 Fr"
              [(ngModel)]="blogue_T2Fr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex4" placeholder="Titre 2 En" [(ngModel)]="blogue_T2En">
            </angular-editor>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Paragraphe 2
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex3" placeholder="Paragraphe 2 Fr"
              [(ngModel)]="blogue_P2Fr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex4" placeholder="aragraphe 2 En" [(ngModel)]="blogue_P2En">
            </angular-editor>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Titre 3
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex5" placeholder="Titre 3 Fr"
              [(ngModel)]="blogue_T3Fr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex6" placeholder="Titre 3 En" [(ngModel)]="blogue_T3En">
            </angular-editor>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Paragraphe 3
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="display-flex">
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex5" placeholder="Paragraphe 3 Fr"
              [(ngModel)]="blogue_P3Fr">
            </angular-editor>
          </div>
          <div class="txt">
            <angular-editor [config]="editorConfig2" name="tex6" placeholder="aragraphe 3 En" [(ngModel)]="blogue_P3En">
            </angular-editor>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Image
          </mat-panel-title>
        </mat-expansion-panel-header>
        <input id="input_file" type="file" style="display: none;" value="importer" name="fghjk"
          (change)="onChangeImagefile($event)">
        <button [disabled]="generaleService.disabled" (click)="openFrmImage('ajouter')" mat-raised-button
          class="colorGreen">Ajouter</button>
        <div>
          <img [id]="img.File_Id" (click)="openFrmImage('modifier',img)" [src]="img.File_Content" class="image-content"
            *ngFor="let img of listeImagesSelectedBlogue">
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    
  </div>
  <div class="liste">
    <h4>Liste Blogues</h4>
    
    <app-liste #listeBlogueComponen [showFilter]="false" [heightTable]="'400'" [displayedColumnsBrut]="columns"
      (btnTable)="clickBtnHeat($event)">
    </app-liste>
  </div>
</div>
<ng-template #frmSousType>
      <mat-form-field>
        <input matInput name="Art_Des4" 
            [(ngModel)]="sousTypeFr" placeholder="Sous type" >
    </mat-form-field>
    <mat-form-field>
        <input matInput name="Art_Des4" 
            [(ngModel)]="sousTypeEn" placeholder="Sous type" >
    </mat-form-field>
    <button  (click)="ajouterSousType()" [disabled]="generaleService.disabled" mat-raised-button
              class="colorGreen btn">Ajouter</button>
            <button (click)="supprimerSousType()" [disabled]="generaleService.disabled" mat-raised-button
              class="colorReed btn">Supprimer</button>
      <app-liste #listeSousTypeComponen [showFilter]="false" [heightTable]="'300'" [displayedColumnsBrut]="columnsSousType">
        </app-liste>
    </ng-template>